exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cipher_tabs[data-v-43f3068e] {\n  padding: 12px;\n}\n", ""]);

// exports
